(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name usuaris.controller:UsuarisCtrl
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio.usuaris')
    .controller('UsuarisCtrl', UsuarisCtrl);

  function UsuarisCtrl() {
    var vm = this;
    vm.ctrlName = 'UsuarisCtrl';
      

  }
}());
